module.exports = __webpack_public_path__ + "static/media/silkycloud-silver-1.adbcc211.png";